import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Actions, DealsActionData, RequestActions } from 'src/app/pages/dashboards/clients/interface/data.interface';
import { ServiceInfoClientService } from '../../../service/service-info-client.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-new-activiti',
  templateUrl: './modal-new-activiti.component.html',
  styleUrls: ['./modal-new-activiti.component.scss']
})
export class ModalNewActivitiComponent {

  public request: RequestActions;
  public dataDeal: DealsActionData;
  @Output() dato: EventEmitter<any> = new EventEmitter();

  public formNuevaActividad = new FormGroup({
    estado: new FormControl('', [Validators.required]),
    comentario: new FormControl('', [Validators.required])
  });

  constructor(@Inject(MAT_DIALOG_DATA)public data: any, private infoService: ServiceInfoClientService, private dialogRef: MatDialogRef<ModalNewActivitiComponent>) {
    this.dataDeal = data;
  }

  public submit() {
    var { estado } = this.formNuevaActividad.value;
    switch (estado) {
      case 'aprobado':
        this.aproveDeal();
        break;
      case 'rechazado':
        this.rejectDeal();
        break;
      case 'informacion':
        this.pendingDeal();
        break;
      default:
        console.log('Opcion No Valida');
        break;
    }
  }

  public aproveDeal() {
    var { comentario } = this.formNuevaActividad.value;
    this.request = {
      userIdApi: this.dataDeal.userId,
      dealId: this.dataDeal.dealId,
      dealActionId: this.dataDeal.actions.id,
      resolutionComment: comentario
    };
    this.infoService.putDealAprove(this.request).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: "Estado Actualizado"
        });
        this.dialogRef.close(res);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error
        });
      }
    });
  }

  public rejectDeal() {
    var { comentario } = this.formNuevaActividad.value;
    this.request = {
      userIdApi: this.dataDeal.userId,
      dealId: this.dataDeal.dealId,
      dealActionId: this.dataDeal.actions.id,
      resolutionComment: comentario
    };
    this.infoService.putDealReject(this.request).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: "Estado Actualizado"
        });
        this.dialogRef.close(res);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error
        });
      }
    });
  }

  public pendingDeal() {
    var { comentario } = this.formNuevaActividad.value;
    this.request = {
      userIdApi: this.dataDeal.userId,
      dealId: this.dataDeal.dealId,
      dealActionId: this.dataDeal.actions.id,
      resolutionComment: comentario
    };
    this.infoService.putDealPending(this.request).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: "Trato Actualizado"
        });
        this.dialogRef.close(res);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error
        });
      }
    });
  }
}
